import React, { useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import './DonationPage.css';

const DonationPage = ({ onNavigate }) => {
  const [amount, setAmount] = useState('');
  const [customAmount, setCustomAmount] = useState('');
  const [selectedFrequency, setSelectedFrequency] = useState('one-time');

  const predefinedAmounts = [10, 25, 50, 100, 250, 500];

  const handleSubmit = (e) => {
    e.preventDefault();
    const finalAmount = amount === 'custom' ? customAmount : amount;
    alert(`Thank you for your ${selectedFrequency} donation of £${finalAmount}!`);
  };

  return (
    <div className="dp-page">
      <Navbar onNavigate={onNavigate} light />

      <div className="dp-container">
        {/* Logo & Organisation Name */}
        <div className="dp-org-header">
          <img src="/Sndp/logo.png" alt="Pravasi SNDP Yogam Logo" className="dp-org-logo" />
          <p className="dp-org-name">
            PRAVASI SNDP YOGAM UK<br />
            പ്രവാസി എസ്.എൻ.ഡി.പി യോഗം യു.കെ
          </p>
        </div>

        {/* Page Title */}
        <div className="dp-title-block">
          <h2 className="dp-title">
            Support Our Cause | ഞങ്ങളുടെ ലക്ഷ്യത്തെ പിന്തുണയ്ക്കുക
          </h2>
          <div className="dp-title-bar" />
        </div>

        {/* Introduction */}
        <div className="dp-intro">
          <p>
            Your generous donation helps us continue our mission of social welfare, cultural preservation,
            and community development. Every contribution makes a difference.
          </p>
          <p className="dp-intro-malayalam">
            നിങ്ങളുടെ ഉദാരമായ സംഭാവന സാമൂഹിക ക്ഷേമം, സാംസ്കാരിക സംരക്ഷണം, സമൂഹ വികസനം എന്നിവയിലെ
            ഞങ്ങളുടെ ദൗത്യം തുടരാൻ സഹായിക്കുന്നു.
          </p>
        </div>

        <form className="dp-form" onSubmit={handleSubmit}>
          {/* Donation Frequency */}
          <div className="dp-section">
            <h3 className="dp-section-title">Donation Frequency</h3>
            <div className="dp-frequency-options">
              <label className={`dp-frequency-option ${selectedFrequency === 'one-time' ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="frequency"
                  value="one-time"
                  checked={selectedFrequency === 'one-time'}
                  onChange={(e) => setSelectedFrequency(e.target.value)}
                />
                <span>One-time</span>
              </label>
              <label className={`dp-frequency-option ${selectedFrequency === 'monthly' ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="frequency"
                  value="monthly"
                  checked={selectedFrequency === 'monthly'}
                  onChange={(e) => setSelectedFrequency(e.target.value)}
                />
                <span>Monthly</span>
              </label>
              <label className={`dp-frequency-option ${selectedFrequency === 'yearly' ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="frequency"
                  value="yearly"
                  checked={selectedFrequency === 'yearly'}
                  onChange={(e) => setSelectedFrequency(e.target.value)}
                />
                <span>Yearly</span>
              </label>
            </div>
          </div>

          {/* Donation Amount */}
          <div className="dp-section">
            <h3 className="dp-section-title">Donation Amount (£)</h3>
            <div className="dp-amount-grid">
              {predefinedAmounts.map((amt) => (
                <label key={amt} className={`dp-amount-option ${amount === amt.toString() ? 'selected' : ''}`}>
                  <input
                    type="radio"
                    name="amount"
                    value={amt}
                    checked={amount === amt.toString()}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                  <span>£{amt}</span>
                </label>
              ))}
              <label className={`dp-amount-option ${amount === 'custom' ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="amount"
                  value="custom"
                  checked={amount === 'custom'}
                  onChange={(e) => setAmount(e.target.value)}
                />
                <span>Custom</span>
              </label>
            </div>

            {/* Custom Amount Input */}
            {amount === 'custom' && (
              <div className="dp-custom-amount">
                <label className="dp-field-label">Custom Amount (£)</label>
                <input
                  type="number"
                  className="dp-custom-input"
                  placeholder="Enter amount"
                  value={customAmount}
                  onChange={(e) => setCustomAmount(e.target.value)}
                  min="1"
                  required
                />
              </div>
            )}
          </div>

          {/* Donor Information */}
          <div className="dp-section">
            <h3 className="dp-section-title">Donor Information | ദാതാവിന്റെ വിവരങ്ങൾ</h3>
            <div className="dp-field-group">
              <div className="dp-field">
                <label className="dp-field-label">Full Name / പൂർണ്ണ നാമം *</label>
                <input type="text" className="dp-input" placeholder="Enter your full name" required />
              </div>
              <div className="dp-field">
                <label className="dp-field-label">Email / ഇമെയിൽ *</label>
                <input type="email" className="dp-input" placeholder="Enter your email" required />
              </div>
              <div className="dp-field">
                <label className="dp-field-label">Phone Number / ഫോൺ നമ്പർ</label>
                <input type="tel" className="dp-input" placeholder="Enter your phone number" />
              </div>
              <div className="dp-field">
                <label className="dp-field-label">Address / വിലാസം (Optional)</label>
                <textarea className="dp-textarea" placeholder="Enter your address" rows="3"></textarea>
              </div>
            </div>
          </div>

          {/* Message */}
          <div className="dp-section">
            <h3 className="dp-section-title">Message (Optional) | സന്ദേശം</h3>
            <textarea
              className="dp-textarea"
              placeholder="Leave a message or dedication..."
              rows="4"
            ></textarea>
          </div>

          {/* Privacy Notice */}
          <div className="dp-privacy">
            <label className="dp-checkbox-label">
              <input type="checkbox" required />
              <span>
                I agree to the privacy policy and understand that my information will be used solely
                for donation processing and communication purposes.
              </span>
            </label>
          </div>

          {/* Submit Button */}
          <button type="submit" className="dp-submit-btn" disabled={!amount}>
            Proceed to Payment
          </button>
        </form>
      </div>

      <Footer />
    </div>
  );
};

export default DonationPage;
